import React from 'react';
import PropTypes from 'prop-types';

const iconPropertyTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
  width: PropTypes.number,
};

type IconProperties = PropTypes.InferProps<typeof iconPropertyTypes> & {
  children?: React.ReactNode;
  height?: number;
  width?: number;
};

const Icon = ({ width = 24, height = 24, children }: IconProperties) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    height={height}
  >
    <g
      transform={`scale(${width / 40} ${height / 40})`}
    >
      {children}
    </g>
  </svg>
);

Icon.propTypes = iconPropertyTypes;

export default Icon;
